import Vue from 'vue'
import { SelectFrachise } from './SelectFranchise'
import { SelectPartner } from './SelectPartner'

export const SelectFranchisePartner = Vue.component('SelectFranchisePartner', {
	name: 'SelectFranchisePartner',
    data: () => ({
        franchiseId: -1,
        partnerId: -1,
        partnerList: new Array()
    }),

    render() {
        return(
            <div>
                <SelectFrachise 
                    on={{ 
                        franchiseChange: (franchiseId: number) => {
                            this.franchiseId = franchiseId 
                            this.$emit('franchiseChange', this.franchiseId)
                        }
                    }}
                />

                <SelectPartner 
                    franchiseId={this.franchiseId} 
                    on={{ 
                        partnerChange: (partnerId: number) => {
                            this.partnerId = partnerId
                            this.$emit('partnerChange', this.partnerId)
                        }
                    }}
                />
            </div>
        )
    },
})
